module.exports = __webpack_public_path__ + "img/yn_yu.68ecca54.png";